import styled from 'styled-components';
import { TextAreaBox } from '@lib/common';
import { getSize, getColor } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Styles
export var TitleWithTagContainer = styled.div.withConfig({
  displayName: "card-titlecomponent__TitleWithTagContainer",
  componentId: "sc-1j04whg-0"
})(["display:flex;align-items:center;flex:1;min-width:0;position:relative;overflow:visible;word-wrap:break-word;overflow-wrap:break-word;"]);
export var TitleArea = styled.div.withConfig({
  displayName: "card-titlecomponent__TitleArea",
  componentId: "sc-1j04whg-1"
})(["flex:1;min-width:0;display:flex;align-items:", ";overflow:visible;word-wrap:break-word;overflow-wrap:break-word;"], function (_ref) {
  var $isEditing = _ref.$isEditing;
  return $isEditing ? 'flex-start' : 'center';
});
export var PinButtonContainer = styled.div.withConfig({
  displayName: "card-titlecomponent__PinButtonContainer",
  componentId: "sc-1j04whg-2"
})(["position:absolute;top:0;right:0;display:flex;align-items:center;z-index:10;"]);
export var TitleTextArea = styled(TextAreaBox).withConfig({
  displayName: "card-titlecomponent__TitleTextArea",
  componentId: "sc-1j04whg-3"
})(["font-weight:700;font-size:", ";padding:", ";border:none;width:100%;line-height:", ";word-wrap:break-word;overflow-wrap:break-word;white-space:pre-wrap;resize:none;vertical-align:top;border-radius:unset;overflow:hidden;background:transparent !important;", " ", " &:focus{outline:none;border:none;box-shadow:none;}.ant-input{border:none !important;box-shadow:none !important;padding:0 !important;font-weight:700;font-size:", ";line-height:", ";resize:none !important;overflow:hidden !important;background:transparent !important;word-wrap:break-word !important;overflow-wrap:break-word !important;white-space:pre-wrap !important;}"], getSize('typo16'), getSize('padding0'), getSize('typo24'), function (_ref2) {
  var $readonly = _ref2.$readonly;
  return $readonly ? "\n    cursor: default;\n    pointer-events: none;\n  " : "\n    cursor: text;\n  ";
}, function (_ref3) {
  var $isEditing = _ref3.$isEditing,
      $isHovered = _ref3.$isHovered;
  return !$isEditing ? "\n    pointer-events: ".concat($isHovered ? 'auto' : 'none', ";\n  ") : '';
}, getSize('typo16'), getSize('typo24'));
var StyledTag = styled.div.withConfig({
  displayName: "card-titlecomponent__StyledTag",
  componentId: "sc-1j04whg-4"
})(["display:inline-flex;align-items:center;justify-content:center;padding:", " ", ";font-size:", ";line-height:", ";color:", ";background:#dbeafe;border-radius:", ";margin-right:", ";font-weight:700;text-transform:uppercase;flex-shrink:0;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;"], getSize('padding2'), getSize('padding8'), getSize('typo12'), getSize('typo16'), getColor('fillIntActive'), getSize('radiusS'), getSize('padding8')); // Component

export var CardTitle = function CardTitle(_ref4) {
  var _ref4$tagLabel = _ref4.tagLabel,
      tagLabel = _ref4$tagLabel === void 0 ? 'SECTION' : _ref4$tagLabel,
      title = _ref4.title,
      _ref4$titleVariant = _ref4.titleVariant,
      titleVariant = _ref4$titleVariant === void 0 ? 'default' : _ref4$titleVariant,
      _ref4$isEditing = _ref4.isEditing,
      isEditing = _ref4$isEditing === void 0 ? false : _ref4$isEditing,
      _ref4$isReadonly = _ref4.isReadonly,
      isReadonly = _ref4$isReadonly === void 0 ? false : _ref4$isReadonly,
      _ref4$isHovered = _ref4.isHovered,
      isHovered = _ref4$isHovered === void 0 ? false : _ref4$isHovered,
      placeholder = _ref4.placeholder,
      onChange = _ref4.onChange,
      onBlur = _ref4.onBlur,
      onFocus = _ref4.onFocus,
      onKeyDown = _ref4.onKeyDown,
      onClick = _ref4.onClick,
      autoFocus = _ref4.autoFocus,
      pinButton = _ref4.pinButton;
  // Allow empty title to be displayed (don't force default value here)
  var displayTitle = title !== null && title !== void 0 ? title : '';
  return /*#__PURE__*/_jsxs(TitleWithTagContainer, {
    children: [/*#__PURE__*/_jsx(StyledTag, {
      children: tagLabel
    }), /*#__PURE__*/_jsxs(TitleArea, {
      $isEditing: isEditing,
      children: [pinButton && /*#__PURE__*/_jsx(PinButtonContainer, {
        children: pinButton
      }), /*#__PURE__*/_jsx(TitleTextArea, {
        value: displayTitle,
        onChange: isEditing ? onChange : undefined,
        onBlur: isEditing ? onBlur : undefined,
        onFocus: isEditing ? onFocus : undefined,
        onKeyDown: isEditing ? onKeyDown : undefined,
        onClick: !isEditing && !isReadonly ? onClick : undefined,
        placeholder: placeholder,
        autoFocus: autoFocus,
        readOnly: !isEditing || isReadonly,
        $readonly: isReadonly,
        $isEditing: isEditing,
        $isHovered: isHovered && !isReadonly,
        $variant: titleVariant,
        autoSize: {
          minRows: 1
        }
      })]
    })]
  });
};